import * as React from "react";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { observer, inject } from "mobx-react";
import { UitkCardAloha } from "uitk-react-cards";
import { LobFormWithTabs } from "src/components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs.tsx";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import {
  UitkLayoutConditionalGridColumnRow,
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutGridItem,
} from "uitk-react-layout-grid";

export interface TabbedWizardCardProps {
  context?: ExtendedContextStore;
  wizardState: ClientWizardStateStore;
  wizardFormChildren: React.ReactElement[];
  wrappingClassNames?: string;
  cardClassNames?: string;
  cardContentClassNames?: string;
  tabGroupClassNames?: string;
  wizardFormClassNames?: string;
  trackOnChangeTab?: (tabName: string) => void;
}

/**
 * Returns a tabbed wizard within a uitk-card
 * Padding/styling of elements within card are handed down by parent region
 * Assumes any non-wizard form children are handled by parent region
 */
export const TabbedWizardCard: React.FunctionComponent<TabbedWizardCardProps> = inject(
  "wizardState",
  "context"
)(
  observer(
    ({
      context,
      wizardState,
      wizardFormChildren,
      wrappingClassNames = "",
      cardClassNames = "",
      cardContentClassNames = "",
      tabGroupClassNames = "",
      wizardFormClassNames = "",
      trackOnChangeTab,
    }: TabbedWizardCardProps) => {
      if (!wizardState) {
        return null;
      }
      const { halfWizard } = wizardState.globalWizardState.config;
      const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, large: 12 };
      const cardColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: halfWizard ? 6 : 12 };
      const isSingleLOB = wizardFormChildren?.length === 1;
      const paddingTopClassName = isSingleLOB ? "all-y-padding-six" : "all-b-padding-six";
      const cardClassName = `${paddingTopClassName} ${cardClassNames}`;

      return (
        <UitkLayoutGrid columns={mainGridColumns} className={`wizardCard ${wrappingClassNames}`}>
          <UitkLayoutGridItem colSpan={cardColSpan}>
            <UitkCardAloha className={cardClassName}>
              <div className={cardContentClassNames}>
                {isSingleLOB ? (
                  wizardFormChildren
                ) : (
                  <LobFormWithTabs
                    context={context}
                    lobForms={wizardFormChildren}
                    wizardFormClassNames={wizardFormClassNames}
                    tabGroupClassNames={tabGroupClassNames}
                    trackOnChangeTab={trackOnChangeTab}
                  />
                )}
              </div>
            </UitkCardAloha>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      );
    }
  )
);
